// extracted by mini-css-extract-plugin
module.exports = {"statusSwitcher":"StatusSwitcher_statusSwitcher__xH_ow","status":"StatusSwitcher_status__V4qMN","selected":"StatusSwitcher_selected__SsylC","spin":"StatusSwitcher_spin__ywB_i"};